<template>
    <div class="key-advantages-section">
        <PageFrameContainer>
            <div class="key-advantages">
                <MainPageKeyAdvantage v-for="(i,index) in $t('pages.main.keyAdvantages.advantages')"
                                      :key="index"
                                      :title="i.title" :icon="'key_'+(index+1)">
                    {{i.text}}
                </MainPageKeyAdvantage>
            </div>
        </PageFrameContainer>
    </div>

</template>

<script>
    import MainPageKeyAdvantage from "../parts/MainPageKeyAdvantage";
    import PageFrameContainer from "../../../components/PageFrameContainer";

    export default {
        name: "KeyAdvantagesSection",
        components: {PageFrameContainer, MainPageKeyAdvantage}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    .key-advantages-section {
        padding-top: 2em;
        padding-bottom: 3em;
    }

    .key-advantages {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 1.5em;
        align-items: start;
    }

    @media (max-width: 45em) {
        .key-advantages {
            grid-template-columns: 1fr;
        }
    }

    @media (min-width: 45em) {
        .key-advantages {
            grid-auto-columns: 1fr;
        }
    }

    .key-advantages div {
        display: grid;
    }

    .key-advantage-image {
        width: 100%;
        height: auto;
        max-height: 10rem;
        padding: 0 20% 0 20%;
    }

</style>